import { render } from "./studydetail.vue?vue&type=template&id=0d21b176&scoped=true&ts=true"
import script from "./studydetail.vue?vue&type=script&lang=ts"
export * from "./studydetail.vue?vue&type=script&lang=ts"

import "./studydetail.vue?vue&type=style&index=0&id=0d21b176&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d21b176"]])

export default __exports__